module.exports = __webpack_public_path__ + "img/layout-one-icon-17022022.5a8835e9.svg";